module.exports = __webpack_public_path__ + "img/icon_close.489f9e6b.svg";